<template>
    <div class="mb-2">
        <a
            v-if="!failed"
            :href="attachment.url"
            target="_blank"
            rel="noopener noreferrer"
            class="block"
        >
            <img
                :src="attachment.url"
                :alt="attachment.filename"
                class="max-h-64 max-w-full rounded-xl border border-black/10 object-contain"
                @error="failed = true"
            />
        </a>

        <!-- Fallback shown when the image has expired (deleted after retention)
             or failed to load: a neutral placeholder plus the original filename,
             so the user still sees that an image was part of this message. -->
        <div
            v-else
            class="flex items-center gap-2 rounded-xl border px-3 py-2 text-xs"
            :class="
                dark
                    ? 'border-white/20 bg-white/10 text-white/80'
                    : 'border-gray-200 bg-gray-50 text-gray-500'
            "
        >
            <svg
                class="h-8 w-8 shrink-0 opacity-70"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                stroke-width="1.5"
                aria-hidden="true"
            >
                <rect x="3" y="4" width="18" height="16" rx="2" />
                <circle cx="8.5" cy="9.5" r="1.5" />
                <path
                    d="M4 17l4.5-4.5a1.5 1.5 0 012 0L15 17m-2-3l2-2a1.5 1.5 0 012 0l3 3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </svg>
            <span class="min-w-0">
                <span class="block truncate font-medium">{{
                    attachment.filename
                }}</span>
                <span class="block opacity-70">{{
                    t("vue.ai_chat_image_unavailable")
                }}</span>
            </span>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { ref } from "vue";
import type { IAiChatMessageAttachment } from "@/types/AiChat/IAiChat";
import { useTranslations } from "@/composables/useTranslations";

withDefaults(
    defineProps<{
        attachment: IAiChatMessageAttachment;
        dark?: boolean;
    }>(),
    { dark: false },
);

const { t } = useTranslations();
const failed = ref(false);
</script>
